import { lpAllocationService } from '@/services/lpAllocationService';
import type { LpAllocations, LpAllocationsUpdate } from '@/types/lpAllocation';

import { queryKeys } from './queryKeys';
import { useApiMutation } from './useApiMutation';
import { useApiQuery } from './useApiQuery';

export const useLpAllocations = (
  fundId: string,
  fundTransactionId: string,
  enabled: boolean = true
) => {
  return useApiQuery<LpAllocations>(
    queryKeys.fundTransactions.lpAllocations(fundId, fundTransactionId),
    () => lpAllocationService.get(fundTransactionId),
    { enabled: enabled && !!fundId && !!fundTransactionId }
  );
};

export const useReplaceLpAllocations = (
  fundId: string,
  fundTransactionId: string
) => {
  return useApiMutation<{ id: string }, unknown, LpAllocationsUpdate>(
    (update) => lpAllocationService.replace(fundTransactionId, update),
    {
      invalidateKeys: [queryKeys.fundTransactions.lpAllocationsAll(fundId)],
      successMessage: 'LP allocation saved',
    }
  );
};

export const useResetLpAllocations = (
  fundId: string,
  fundTransactionId: string
) => {
  return useApiMutation<void, unknown, void>(
    () => lpAllocationService.resetToProRata(fundTransactionId),
    {
      invalidateKeys: [queryKeys.fundTransactions.lpAllocationsAll(fundId)],
      successMessage: 'LP allocation reset to pro-rata',
    }
  );
};
